<template>
    <div class="secondary-menu moderation_photo">
        <div class="secondary-menu-header">
          <i class="back" @click="goBack"></i>
          <div class="title">{{ trans('moderation') }}</div>
        </div>

        <div class="secondary-menu-body">
          <div v-if="!help_slider_enabled" class="moderation">
            <div v-if="!loaded && !photos.length" class="spinner-container">
              <img class="preloader"
                   src="/assets/img/preloader.svg"
                   alt="">
            </div>
            <div v-else-if="photos.length">
              <div v-if="photos.length" class="photo-preview" :style="{'background': `url(${photos[0].url}) no-repeat center / cover`}">
              </div>
              <div class="buttons">
                <div class="rounded">
                  <button @click="openHelpSlider" class="help"></button>
                  <button @click="ratePhoto(photos[0].id, 'safe')" class="green" :class="{'non-active':current_rate !== null && current_rate !== 'safe','active':current_rate === 'safe'}">safe</button>
                  <button @click="ratePhoto(photos[0].id, 'soft')" class="yellow" :class="{'non-active':current_rate !== null && current_rate !== 'soft','active':current_rate === 'soft'}">soft</button>
                  <button @click="ratePhoto(photos[0].id, 'hard')" class="purple" :class="{'non-active':current_rate !== null && current_rate !== 'hard','active':current_rate === 'hard'}">hard</button>
                </div>
                <div class="bottom-buttons">
                  <button @click="ratePhoto(photos[0].id, 'prohibited')" class="report" :class="{'non-active':current_rate !== null && current_rate !== 'prohibited','active':current_rate === 'prohibited'}">!</button>
                  <button @click="sendRequest" class="skip" :class="rateClass">{{skipText}}</button>
                </div>
              </div>
            </div>
            <div class="not_exists" v-else>
              {{trans('no_more_photos_for_moderation')}}
            </div>
          </div>
          <div v-else class="moderation_help" @click="swipeLeft">
            <vue2-gesture :type="'swipeLeft'" :call="handleGesture.bind(this, 'swipeLeft')">
              <vue2-gesture :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
                <div v-if="key === active_help_slider" v-for="(help_slider,key) in help_sliders" :style="{'background': `url(/main/img/moderation-slider/${help_slider}) no-repeat center / contain`}" class="moderation_help_item">

                </div>
              </vue2-gesture>
            </vue2-gesture>
            <div class="moderation_help-swipe">
              <i class="left" @click="swipeRight"></i>
              <span v-if="!isDesktop" class="middle">Swipe</span>
              <i class="right" @click="swipeLeft"></i>
            </div>
          </div>
        </div>
      </div>
</template>

<script>

import {mapActions, mapState} from "vuex";

    export default {
        mixins: [require('@general/lib/mixin').default],
        data() {
            return {
              help_slider_enabled: false,
              active_help_slider: 0,
              help_sliders: [
                  'moderation_slider_1.jpg',
                  'moderation_slider_2.jpg',
                  'moderation_slider_3.jpg',
                  'moderation_slider_4.jpg',
                  'moderation_slider_5.jpg'
              ],
              photos: [],
              current_rate:null,
              skipped_photos: 0,
              loaded: false
            }
        },
        components: {
        },
        computed:{
          ...mapState({
              profile: 'profile'
          }),
          skipText(){
            if(this.current_rate){
              if(this.current_rate === 'prohibited'){
                return 'report';
              }else{
                return 'send';
              }
            }else{
              return 'skip';
            }
          },
          rateClass(){
            let classes = {
              'safe' : 'green',
              'soft' : 'yellow',
              'hard' : 'purple',
              'prohibited' : 'red'
            };
            if(this.current_rate){
              return classes[this.current_rate];
            }else{
              return '';
            }
          }
        },
        mounted() {
          this.getPhotosForModeration();
          if(!this.profile.help_slider_seen){
            this.help_slider_enabled = true;
          }
        },
        beforeDestroy() {
        },
        methods: {
          ...mapActions([
            'closeProfileModerations',
            'openProfileHelp'
          ]),
          swipeRight(){
            if(this.active_help_slider !== 0) {
              this.active_help_slider--;
            }
          },
          swipeLeft(){
            this.active_help_slider++;
            if(this.active_help_slider >= 5){
              this.help_slider_enabled = false;
              this.active_help_slider = 0;
              if(!this.profile.help_slider_seen){
                axios.post('/api/updateUser', {help_slider_seen: 1})
                store.commit('updateUser', { help_slider_seen: 1 })
              }
            }
          },
          handleGesture(str, e) {
            if (str === 'swipeRight') {
              this.swipeRight();
            }
            if (str === 'swipeLeft') {
              this.swipeLeft();
            }
          },
          openHelpSlider(){
            this.help_slider_enabled = true;
          },
          goBack(){
            if(this.isDesktop){
              this.closeProfileModerations();
              this.openProfileHelp();
            }else{
              this.goTo('/profile/help')
            }
          },
          sendRequest(){
            let rate = this.current_rate ? this.current_rate : 'skip';
            let rates = {
              'safe' : 'clear',
              'soft' : 'soft',
              'hard' : 'adult',
              'prohibited' : 'prohibited',
              'skip' : 'skip'
            };
            let photo_id = this.photos[0].id;
            axios.post(`/api/photos/ratePhoto`, {photo_id: photo_id,rate:rates[rate]})
                .then((data) => {
                  if(data.data.success){

                  }
                })
            if(this.photos.length - 1 <= 2 && this.loaded){
              this.getPhotosForModeration();
            }
            this.photos.splice(0, 1)
            if(rate === 'skip'){
              this.skipped_photos += 1;
            }
            if(this.skipped_photos > 4){
              this.photos = [];
              this.current_rate = null;
            }else{
              this.current_rate = null;
            }

          },
          ratePhoto(id, rate){
            if(this.current_rate && this.current_rate === rate){
              this.current_rate = null;
            }else{
              this.current_rate = rate;
            }
          },
          getPhotosForModeration(){
            let self = this;
            self.loaded = false;
            axios.get(`/api/photos/getModerationPhotos?except=` + this.photos.map(({id}) => ( id )).join(','))
                .then((photos) => {
                  self.loaded = true;
                  self.photos = self.photos.concat(photos.data);
                })

          },
        }
    }
</script>